// components/ui/button.jsx
import React from 'react';

export function Button({
    children,
    variant = "default", // 'default' | 'outline' | 'inverse'
    size = "md",          // 'sm' | 'md' | 'lg'
    className = "",
    ...props
}) {
    const base = "rounded-xl font-semibold transition duration-150";
    
    const sizes = {
        sm: "text-sm px-3 py-1.5",
        md: "text-base px-4 py-2",
        lg: "text-lg px-5 py-3"
    };

    const variants = {
        default: "bg-green-600 text-white hover:bg-green-700",
        outline: "border border-green-600 text-green-600 hover:bg-green-50",
        inverse: "bg-white text-green-600 border border-green-600 hover:bg-green-50"
    };

    return (
        <button
            className={`${base} ${sizes[size]} ${variants[variant]} ${className}`}
            {...props}
        >
            {children}
        </button>
    );
}
